import script from "./PerformanceView.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformanceView.vue?vue&type=script&setup=true&lang=js"

import "./PerformanceView.vue?vue&type=style&index=0&id=116a5a11&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-116a5a11"]])

export default __exports__